/* Native journal links retain the current preview theme in or outside the owner editor. */
(() => {
  'use strict';
  if (window.PVEditorialNavigation) { window.PVEditorialNavigation.init(); return; }
  const views = new Set(['pv-journal', 'pv-pet-asia', 'pv-news', 'pv-worlds']);
  const path = /^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8}){0,2}\/)?collections\/all\/?$/i;
  const preview = { preview_theme_id: /^\d{1,24}$/, preview_key: /^[a-zA-Z0-9._-]{1,256}$/, _fd: /^[01]$/, _sc: /^[01]$/, pb: /^[01]$/ };
  function destination(link) {
    let url; try { url = new URL(link.getAttribute('href'), location.href); } catch (_) { return null; }
    if (url.origin !== location.origin || !path.test(url.pathname) || url.username || url.password || url.searchParams.getAll('view').length !== 1 || !views.has(url.searchParams.get('view'))) return null;
    const current = new URL(location.href), output = new URL(url.pathname, location.origin);
    output.searchParams.set('view', url.searchParams.get('view'));
    Object.entries(preview).forEach(([key, pattern]) => {
      const values = current.searchParams.getAll(key);
      if (values.length === 1 && pattern.test(values[0])) output.searchParams.set(key, values[0]);
    });
    const theme = window.Shopify && window.Shopify.theme;
    if (!output.searchParams.has('preview_theme_id') && theme && ['unpublished', 'development'].includes(theme.role) && preview.preview_theme_id.test(String(theme.id || ''))) output.searchParams.set('preview_theme_id', String(theme.id));
    return output;
  }
  function init() {
    document.querySelectorAll('a[data-pv-editorial-link]').forEach(link => { const url = destination(link); if (url) link.setAttribute('href', url.pathname + url.search); });
    const article = document.querySelector('[data-pv-article-title]');
    if (article && article.dataset.pvArticleTitle) document.title = `${article.dataset.pvArticleTitle} | PETSVILLE`;
  }
  window.addEventListener('click', event => {
    if (!window.Shopify || !window.Shopify.designMode || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest && event.target.closest('a[data-pv-editorial-link]');
    if (!link || link.hasAttribute('download') || (link.target && link.target.toLowerCase() !== '_self')) return;
    const url = destination(link); if (!url) return;
    event.preventDefault(); event.stopPropagation(); location.assign(url.href);
  }, true);
  window.PVEditorialNavigation = { init };
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
  init();
})();
